import {Request, RequestResponse} from 'requests/RequestConstants';
import {RequestTask} from 'requests/tasks/RequestTaskConstants';
import {SampleGroupResponse} from 'samples/sample-groups/SampleGroupConstants';
import * as net from 'util/Net';

import {
  FulfillmentStatus,
  RequestFulfillment,
  RequestFulfillmentDefinition,
  RequestFulfillmentUpdate,
} from './FulfillmentConstants';

export function fetchRequestResponse(requestId: string): Promise<RequestResponse> {
  return Promise.resolve(net.getJSON(`/1/api/requests/${requestId}/response`));
}

export function listFulfillmentsForRequests(
  requestIds: Array<string>
): Promise<{requestFulfillments: Array<RequestFulfillment>}> {
  return Promise.resolve(
    net.getJSON('/1/api/request-fulfillments', {
      requestIds: requestIds.join(','),
    })
  );
}

export function fetchRequestFulfillments(fulfillmentIds: Array<string>): Promise<
  {
    requestFulfillments: Array<RequestFulfillment>;
    requests: Array<Request>;
    requestTasks: Array<RequestTask>;
  } & SampleGroupResponse
> {
  return Promise.resolve(
    net.postJSON({
      url: '/1/api/request-fulfillments:bulk-get',
      data: {fulfillmentIds},
    })
  );
}

export function updateFulfillment(
  fulfillmentId: string,
  newFulfillment: {statusAfterReview: FulfillmentStatus}
): Promise<{requestFulfillment: RequestFulfillment}> {
  return Promise.resolve(
    net.patchJSON({
      url: `/1/api/request-fulfillments/${fulfillmentId}`,
      data: {fulfillment: newFulfillment},
    })
  );
}

/**
 * Update request fulfillments.
 *
 * @param {array} fulfillmentUpdates - a list of {fulfillmentId, ...newFieldValues} objects.
 *                                     Only the `status` field is currently supported.
 */
export function bulkUpdateFulfillments(
  fulfillmentUpdates: Array<RequestFulfillmentUpdate>
): Promise<{requestFulfillments: Array<RequestFulfillment>}> {
  return Promise.resolve(
    net.patchJSON({
      url: `/1/api/request-fulfillments:bulk-update`,
      data: {fulfillmentUpdates},
    })
  );
}

export function bulkRemoveFulfillments(fulfillmentIdsToRemove: Array<string>): Promise<{}> {
  return net.deletePromise({
    url: `/1/api/request-fulfillments:bulk-delete`,
    data: {fulfillmentIds: fulfillmentIdsToRemove},
  });
}

export function executeIntoExistingEntry(
  entryId: string,
  fulfillments: Array<RequestFulfillmentDefinition>
): Promise<{
  numDuplicates: number;
  entryFulfillments: Array<RequestFulfillment>;
}> {
  return Promise.resolve(
    net.postJSON({
      url: '/1/api/request-fulfillments:execute-into-existing-entry',
      data: {entryId, fulfillments},
    })
  );
}
